import { render, staticRenderFns } from "./classical-remid-adjustment-form.vue?vue&type=template&id=1d65e84f"
import script from "./classical-remid-adjustment-form.vue?vue&type=script&lang=js"
export * from "./classical-remid-adjustment-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports